import React from 'react'
import classes from './MSTTR.module.css'
import { Td, Tr, Link, Grid, useDisclosure } from '@chakra-ui/react'
import { DeleteIcon, EditIcon } from '@chakra-ui/icons'
import TestModal from '../Modals/TestModal'
import DeleteTestAlert from '../Modals/DeleteTestAlert'

function MyStudentsTestsTableRecord({test}) {
    const editDisclosure = useDisclosure()
    const deleteDisclosure = useDisclosure()

    return (
        <Tr>
            <Td>{`${test?.student?.last_name} ${test?.student?.first_name}`}</Td>
            <Td>{test?.subject?.title}</Td>
            <Td>
                {new Date(test?.date).toLocaleString()}
            </Td>
            <Td>{test?.status_id === 1 ? 'Сдан' : 'Не сдан'}</Td>
            <Td>
                <Link isExternal href={test.link}>
                    {test.link}
                </Link>
            </Td>
            <Td>{test.note}</Td>
            <Td>
                <Grid className={classes.icons}>
                    <EditIcon
                        className={classes.editBtn}
                        onClick={editDisclosure.onOpen}
                    />
                    <DeleteIcon 
                        className={classes.deleteBtn}
                        onClick={deleteDisclosure.onOpen}
                    />
                </Grid>
                <TestModal {...{
                    isOpen: editDisclosure.isOpen,
                    onClose: editDisclosure.onClose,
                    title: "Изменение зачёта",
                    test
                }} />
                <DeleteTestAlert {...{
                    isOpen: deleteDisclosure.isOpen,
                    onClose: deleteDisclosure.onClose,
                    test
                }}
                />
            </Td>
        </Tr>
    )
}

export default MyStudentsTestsTableRecord
